import { useResponseHandler } from '@hooks/useResponseHandler';
import { useSession } from '@hooks/useSession';

import { VitalSignObservationRecord } from '@models/vital-sign';

import { useListSleepObservationsQuery } from 'generated/sleep.generated';

export const useGetSleepObservations = (
  code?: string,
  skipQuery?: boolean,
  filterUnpublished?: boolean,
  dateRange?: DateRange
) => {
  const { handleError } = useResponseHandler();
  const {
    state: { activeProfile },
  } = useSession();
  const patient_id = activeProfile?.patient_id ?? '';
  const response = useListSleepObservationsQuery({
    variables: {
      input: {
        patient: patient_id,
        code,
        filterUnpublished,
        dateFrom: dateRange?.dateFrom,
        dateTo: dateRange?.dateTo,
      },
    },
    skip: !patient_id || Boolean(skipQuery),
  });
  const { data, error } = response;
  handleError(error);
  const records = (data?.listSleepObservations.data ?? []).map(
    (r) => new VitalSignObservationRecord(r)
  );
  return { ...response, data: records };
};
